import { render, staticRenderFns } from "./exchangeList.vue?vue&type=template&id=4d2595be&scoped=true"
import script from "./exchangeList.vue?vue&type=script&lang=js"
export * from "./exchangeList.vue?vue&type=script&lang=js"
import style0 from "./exchangeList.vue?vue&type=style&index=0&id=4d2595be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2595be",
  null
  
)

export default component.exports